"use client";

import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/cn";
import { inputClass } from "./fields";

/** Campo de contraseña con botón para mostrarla y aviso de bloqueo de mayúsculas */
export function PasswordInput({
  className,
  onKeyUp,
  ...props
}: Omit<React.ComponentProps<"input">, "type">) {
  const [visible, setVisible] = useState(false);
  const [caps, setCaps] = useState(false);
  return (
    <div className="flex flex-col gap-1.5">
      <div className="relative">
        <input
          {...props}
          type={visible ? "text" : "password"}
          onKeyUp={(e) => {
            setCaps(e.getModifierState?.("CapsLock") ?? false);
            onKeyUp?.(e);
          }}
          className={cn(inputClass, "pr-12", className)}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="absolute top-1/2 right-1.5 grid size-9 -translate-y-1/2 place-items-center rounded-sm text-text-3 transition-colors hover:bg-sand hover:text-forest"
          aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
          aria-pressed={visible}
        >
          {visible ? <EyeOff aria-hidden="true" className="size-[18px]" /> : <Eye aria-hidden="true" className="size-[18px]" />}
        </button>
      </div>
      {caps ? <p className="text-xs font-medium text-gold-text">Tienes activadas las mayúsculas.</p> : null}
    </div>
  );
}
